/* cinematic intro (motion + JS cleanup) + cursor-interactive hero title.
   The intro's animation is CSS-driven off <html class="intro-on"> (armed once per
   session in the head). This file only skips/cleans it up, and — separately — makes
   the hero title react to the cursor. Both are fine-pointer / motion aware. */
(function () {
  'use strict';
  var html = document.documentElement;
  var intro = document.getElementById('intro');

  /* ---------- intro cleanup ---------- */
  if (intro) {
    if (!html.classList.contains('intro-on')) {
      intro.remove();                       // repeat visit / reduced motion: never shown
    } else {
      var done = false;
      var finish = function () {
        if (done) return; done = true;
        html.classList.add('intro-done');   // fast fade (keeps intro-on so it doesn't blink out)
        setTimeout(function () {
          if (intro && intro.parentNode) intro.remove();
          html.classList.remove('intro-on');
        }, 500);
      };
      var skip = document.getElementById('introSkip');
      if (skip) skip.addEventListener('click', finish);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') finish();
      });
      setTimeout(finish, 2800);             // matches the end of the CSS sequence
    }
  }

  /* ---------- cursor-interactive hero title ---------- */
  var title = document.getElementById('heroTitle');
  if (!title) return;
  if (!window.matchMedia('(pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var chars = [];
  [].forEach.call(title.querySelectorAll('.line'), function (line) {
    var words = line.textContent.split(' ');
    line.textContent = '';
    words.forEach(function (word, wi) {
      if (wi > 0) line.appendChild(document.createTextNode(' '));
      var w = document.createElement('span');
      w.className = 'word';                 // words never break mid-way; only spaces wrap
      for (var i = 0; i < word.length; i++) {
        var s = document.createElement('span');
        s.className = 'ch';
        s.textContent = word[i];
        w.appendChild(s);
        chars.push(s);
      }
      line.appendChild(w);
    });
  });

  var hero = title.closest('.hero') || title;
  var centers = [];
  var mScheduled = false;
  function measure() {
    mScheduled = false;
    centers = chars.map(function (s) {
      var r = s.getBoundingClientRect();
      return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    });
  }
  function scheduleMeasure() { if (!mScheduled) { mScheduled = true; requestAnimationFrame(measure); } }
  measure();
  window.addEventListener('resize', scheduleMeasure, { passive: true });
  window.addEventListener('scroll', scheduleMeasure, { passive: true });

  var mx = -1, my = -1, raf = false, R = 150;
  function apply() {
    raf = false;
    for (var i = 0; i < chars.length; i++) {
      var c = centers[i]; if (!c) continue;
      var dx = c.x - mx, dy = c.y - my;
      var d = Math.sqrt(dx * dx + dy * dy);
      if (mx >= 0 && d < R) {
        var f = 1 - d / R;
        var ang = Math.atan2(dy, dx);
        var px = Math.cos(ang) * f * 16;
        var py = Math.sin(ang) * f * 16 - f * 12;
        chars[i].style.transform = 'translate(' + px.toFixed(1) + 'px,' + py.toFixed(1) + 'px) scale(' + (1 + f * 0.3).toFixed(3) + ')';
        chars[i].style.color = 'rgba(255,181,63,' + (0.4 + f * 0.6).toFixed(2) + ')';
      } else if (chars[i].style.transform) {
        chars[i].style.transform = '';
        chars[i].style.color = '';
      }
    }
  }
  hero.addEventListener('pointermove', function (e) {
    mx = e.clientX; my = e.clientY;
    if (!raf) { raf = true; requestAnimationFrame(apply); }
  }, { passive: true });
  hero.addEventListener('pointerleave', function () {
    mx = -1; my = -1;
    if (!raf) { raf = true; requestAnimationFrame(apply); }
  });
})();
